import { Button } from "@solomon-apps/shared/src/components/ui/button";
import {
    ArrowLeftLongIcon,
    ArrowRightLongIcon
} from "@solomon-labs/design/components/icons";
import React from "react";

import { ViewOnlyHint } from "@/components/ViewOnly";

/**
 * Wizard flow navigation — a left-aligned Back / Next pair (long-arrow icons,
 * sunken Back + inverse-raised Next, both outlined so the pair matches in
 * size), with the view-only hint below when applicable.
 * Pure presentation: the parent owns step state and passes the disabled flags
 * + handlers. Lives in the step rail column, outside the step frame, because
 * it's flow navigation, not part of any one step's content.
 */
export function WizardNav({
    backDisabled,
    nextDisabled,
    onBack,
    onNext,
    viewOnly = false
}: {
    backDisabled: boolean;
    nextDisabled: boolean;
    onBack: () => void;
    onNext: () => void;
    /** Shows the desktop-only view-only hint beneath the buttons. */
    viewOnly?: boolean;
}): React.ReactElement {
    return (
        <div className="flex flex-col items-start gap-2">
            <div className="flex items-center gap-3">
                <Button
                    variant="sunken"
                    outline
                    interaction="lifted"
                    size="md"
                    disabled={backDisabled}
                    onClick={onBack}
                >
                    <ArrowLeftLongIcon className="mr-1 size-5 shrink-0" />
                    Back
                </Button>
                <Button
                    variant="inverse-raised"
                    outline
                    interaction="lifted"
                    size="md"
                    disabled={nextDisabled}
                    onClick={onNext}
                >
                    Next
                    <ArrowRightLongIcon className="ml-1 size-5 shrink-0" />
                </Button>
            </div>
            {viewOnly && <ViewOnlyHint />}
        </div>
    );
}
